"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var sso = {
  production: {
    huaercollegiate: {
      protal_url: 'https://huaer.dipont.com',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'huaercollegiate'
    },
    chengducollegiate: {
      protal_url: 'https://kcschengdu.dipont.com',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'chengducollegiate'
    },
    enhertz: {
      protal_url: 'https://int.enhertz.com',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'enhertz',
    }
  },
  uat: {
    huaercollegiate: {
      protal_url: 'http://122.96.107.58:3014',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'huaercollegiate'
    },
    chengducollegiate: {
      protal_url: 'http://122.96.107.58:3016',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'chengducollegiate'
    },
    testcollegiate: {
      protal_url: 'http://122.96.107.58:3017',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'testcollegiate'
    }
  },
  qa: {
    huaercollegiate: {
      protal_url: 'http://kunshan.dipont.com:9296',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'huaercollegiate'
    },
    chengducollegiate: {
      protal_url: 'http://chengdu.dipont.com:9296',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'chengducollegiate'
    },
    testcollegiate: {
      protal_url: 'http://test.dipont.com:9296',
      clientId: 'e65d92d3d9634043848d185a255cac68',
      sso_source: 'testcollegiate'
    }
  }
};
var _default = sso;
exports.default = _default;